import classnames from 'classnames';
import React, { FC, useState } from 'react';

import { Icon, IconTypes } from '@eika/icon';

import { ExpandTableProps } from './ExpandTable';

import './ExpandTableDesktop.scss';

const ExpandTableDesktop: FC<ExpandTableProps> = ({ tableHeader, tableRows, className }) => {
    const [subTableOpenList, setSubTableOpenList] = useState(new Map([[tableRows[0].id, true]]));

    const setSubTableOpen = (id: string) => {
        const open = subTableOpenList.has(id) ? !subTableOpenList.get(id) : true;
        setSubTableOpenList(new Map(subTableOpenList.set(id, open)));
    };

    return (
        <table className={classnames('sgw-expand-table-desktop', className)}>
            <thead>
                <tr>
                    {tableHeader.map((headerElement) => (
                        <th key={headerElement.id}>{headerElement.label}</th>
                    ))}
                </tr>
            </thead>
            {tableRows.map((tableRow) => (
                <React.Fragment key={tableRow.id}>
                    <tbody>
                        <tr className="table-header-row">
                            {tableRow.rowElements.map((rowElement, index) => (
                                <td
                                    key={tableRow.id + tableHeader[index].id}
                                    className={classnames({ 'bold-column': tableHeader[index].boldColumn })}
                                >
                                    {index === 0 && tableRow.subTable.length > 0 ? (
                                        <button
                                            type="button"
                                            aria-expanded={!!subTableOpenList.get(tableRow.id)}
                                            onClick={() => setSubTableOpen(tableRow.id)}
                                        >
                                            {rowElement}
                                            <Icon
                                                type={IconTypes.LITEN_PIL_NED}
                                                className={classnames('arrow-icon', 'icon--24', {
                                                    open: !!subTableOpenList.get(tableRow.id),
                                                })}
                                            />
                                        </button>
                                    ) : (
                                        <span className="table-cell-content">{rowElement}</span>
                                    )}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                    <tbody
                        className={classnames({ collapsed: !subTableOpenList.get(tableRow.id) })}
                        aria-hidden={!subTableOpenList.get(tableRow.id)}
                    >
                        {tableRow.subTable.map((subRow) => (
                            <tr key={subRow.id}>
                                {subRow.rowElements.map((rowElement, i) => (
                                    <td
                                        className={classnames('table-cell', {
                                            'bold-column': tableHeader[i].boldColumn,
                                        })}
                                        key={subRow.id + tableHeader[i].id}
                                    >
                                        {rowElement}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </React.Fragment>
            ))}
        </table>
    );
};

export default ExpandTableDesktop;
